module.exports = __webpack_public_path__ + "static/media/pic6.5efc83ab.jpg";